<template>
	<v-card color="rgba(41, 41, 47, 0.8)">
		<v-card-title> {{ $t("Addflatground") }} </v-card-title>
		<v-card-text>
			<v-form v-model="isValid">
				<v-row class="ma-0">
					<v-col cols="6">
						<v-table hover density="compact" style="background-color: rgba(41, 41, 47, 0)">
							<tbody>
								<tr>
									<td style="width: 50%">
										{{ $t("Flatgroundname") }}
									</td>
									<td>
										<v-text-field variant="underlined" hide-details density="compact" v-model="property.name"
											:rules="[rules.validName, rules.maxLength(100), rules.minLength(1)]" autofocus />
									</td>
								</tr>
							</tbody>
						</v-table>
					</v-col>
				</v-row>
				<v-row class="ma-0">
					<v-col>
						<v-row class="ma-0">
							<v-col class="py-0">
								{{ $t("FLATGROUND_PARAMETERS") }}
							</v-col>
						</v-row>
						<v-row class="ma-0">
							<v-col cols="6">
								<v-table hover density="compact" style="background-color: rgba(41, 41, 47, 0)">
									<tbody>
										<tr>
											<td style="width: 50%">
												{{ $t("With_Slope") }}
											</td>
											<td>
												<v-checkbox color="primary" hide-details density="compact" class="ma-0"
													v-model="withSlope"></v-checkbox>
											</td>
										</tr>
										<!-- 摺り付けピッチ -->
										<tr>
											<td style="width: 50%">
												{{ $t("Distance") }}
											</td>
											<td>
												<DistanceSettingInput variant="underlined" hide-details density="compact" :step="0.001"
													:disabled="!withSlope" :min-value="0.001" :max-value="99.999" :decimal-length="3"
													v-model="property.surfaceSettings.interpolationPitch" />
											</td>
										</tr>
										<tr>
											<td style="width: 50%">
												{{ $t("FLAT_GROUND_SURFACE_COLOR") }}
											</td>
											<td>
												<v-menu>
													<template v-slot:activator="{ props }">
														<v-avatar :color="property.surfaceSettings.color" size="20px" v-bind="props">
														</v-avatar>
													</template>
													<v-color-picker class="ma-0" hide-canvas hide-inputs hide-sliders show-swatches mode="hexa"
														v-model="property.surfaceSettings.color">
													</v-color-picker>
												</v-menu>
											</td>
										</tr>
									</tbody>
								</v-table>
							</v-col>
						</v-row>
					</v-col>
				</v-row>
				<v-row class="ma-0">
					<v-col>
						<!-- 切土設定 -->
						<v-row class="ma-0">
							<v-col class="py-0">
								{{ $t("Cutsetting") }}
							</v-col>
						</v-row>
						<v-row class="ma-0">
							<v-col>
								<property-flat-mound-settings :property="property" :moundTypeSettings="'cutSettings'">
								</property-flat-mound-settings>
							</v-col>
						</v-row>
					</v-col>
					<v-col>
						<!-- 盛土設定 -->
						<v-row class="ma-0">
							<v-col class="py-0">
								{{ $t("Fillsetting") }}
							</v-col>
						</v-row>
						<v-row class="ma-0">
							<v-col>
								<property-flat-mound-settings :property="property" :moundTypeSettings="'fillSettings'">
								</property-flat-mound-settings>
							</v-col>
						</v-row>
					</v-col>
				</v-row>
				<v-row class="ma-0">
					<v-col>
						<v-card-actions class="justify-end">
							<v-btn variant="flat" @click="closeDialog" color="red" :disabled="isFlatGroundAdded">
								{{ $t("CANCEL") }}
							</v-btn>
							<v-btn variant="flat" @click="addFlatGround()" color="primary"
								:disabled="!isValid || addFlatGroundDisabled || isFlatGroundAdded">
								{{ $t("ADD") }}
							</v-btn>
						</v-card-actions>
					</v-col>
				</v-row>
			</v-form>
		</v-card-text>
	</v-card>
</template>

<script lang="ts">
import axios from "axios";
import PropertyFlatMoundSettings from "./PropertyFlatMoundSettings.vue";
import DistanceSettingInput from "./DistanceSettingInput.vue";
import rules from "@/utils/validation-rules.js";
import { FlatgroundObject } from "@/models/objects/FlatgroundObject";
import { useStore } from "vuex";
import { notifyError } from "@/utils/notificationUtils";

export default {
	name: "PropertyDialogFlat",
	components: { PropertyFlatMoundSettings, DistanceSettingInput },
	props: {
		id: String,
		type: Number,
	},
	beforeMount() {
		this.property = new FlatgroundObject();
		this.property.id = this.id;
		const flatGroundData = this.store.getters.viewer.getFlatGroundJSON(this.id);
		if (flatGroundData) {
			this.property.associatedTerrain = flatGroundData.associatedTerrain;
			this.property.points = flatGroundData.points;
		}
	},
	mounted() {
		// this.convertRatioSlopesToPercentSlopes();
	},
	data: () => ({
		isValid: false,
		property: null as FlatgroundObject,
		rules: {
			...rules,
			validName: (v) => !/[~@#$^*()+=[\]{}|\\,?:<>!'"/;₹€&`%]/.test(v),
		},
		isFlatGroundAdded: false,
		store: useStore(),
	}),
	computed: {
		withSlope: {
			get() {
				return this.property.surfaceSettings.withSlope;
			},
			set(value) {
				this.property.surfaceSettings.withSlope = value;
			},
		},
		roadParameterSlopeUnit() {
			return this.store.state.roadParameterSlopeUnit;
		},
		cutSettingSlopeUnit() {
			return this.store.state.cutSettingSlopeUnit;
		},
		fillSettingSlopeUnit() {
			return this.store.state.fillSettingSlopeUnit;
		},
		addFlatGroundDisabled: function () {
			return (
				this.property.name === null ||
				this.property.name === "" ||
				/^\s*$/.test(this.property.name) ||
				/[~@#$^*()+=[\]{}|\\,?:<>!'"/;₹€&`%]/.test(this.property.name)
			);
		},
	},
	methods: {
		resetProperty() {
			this.property.update(this.property.default);
			// this.convertRatioSlopesToPercentSlopes();
			this.isFlatGroundAdded = false;
		},
		closeDialog() {
			this.store.getters.viewer.removePolygon(this.id);
			this.$emit("close", false);
		},
		async addFlatGround() {
			this.isFlatGroundAdded = true;

			try {
				// ローディング開始
				await this.store.dispatch("executeWithSpinner", async () => {
					try {
						this.store.getters.viewer.removePolygon(this.id);
						await this.property.loadInViewer();

						// Soil volume calculation
						const volume =
							await this.store.getters.viewer.volumeCalculationForFlatGround(
								this.id,
							);
						const { cutVolume = 0, fillVolume = 0 } = volume ?? {};
						this.property.cutVolume = cutVolume.toFixed(3);
						this.property.fillVolume = fillVolume.toFixed(3);

						// Surface area calculation
						const area =
							this.store.state.viewer.calculateSurfaceAreaOfFlatGround(this.id);
						this.property.surfaceArea = area.toFixed(3);

						const objConnectionJSON =
							this.store.getters.viewer.getConnectionsInSiteJSON();
						// this.property.maxHeight = maxHeight.toFixed(3);
						const propsJSON = await this.property.toJSON();
						const res = await axios.post(
							`${import.meta.env.VITE_API_BASE}/obj/${this.$route.query.siteId}`,
							{
								siteId: this.$route.query.siteId,
								objJSON: {},
								objProps: propsJSON,
								objConnectionJSON: objConnectionJSON,
							},
							{
								auth: this.store.state.authObject,
							},
						);
						// オブジェクトリストの更新
						await this.store.dispatch("object/get_obj", this.id);
						// 追加した平場を可視化する
						const addedObj = this.store.state.object.objects.find(
							(entity) => entity.id === this.id,
						);
						if (addedObj) {
							addedObj.isLoaded = true;
							addedObj.isShow = true;
						}
					} catch (e) {
						console.error(e);
						this.store.getters.viewer.removePolygon(this.id);
						notifyError(this, this.$t("FLAT_SAVE_FAILURE"));
					}
				});
			} finally {
				this.$emit("close", false);
			}
		},
		isNum(val) {
			return typeof val == "number";
		},
	},
};
</script>
